module.exports = __webpack_public_path__ + "static/media/010.8066c3b5.jpg";